import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tEn from '../locales/en/translations.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: tEn,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
